export interface IDonorConnectSurveyType {
    DASH: boolean,
    DCN: boolean,
    NKR: boolean
}
